import { TENANT_TYPES } from 'constants-channel';

export default function isTenantLocationChannel(channel: any) {
  return (
    TENANT_TYPES.includes(channel.type) && !channel.isSub && channel.parent
  );
}
